var map = {
	"./1714802271525.jpeg": 2430,
	"./60750.jpg": 240,
	"./AWS.png": 9997,
	"./IBM.png": 8712,
	"./IBMC.png": 8337,
	"./IMG-20230316-WA0011.jpg": 1396,
	"./IMG-20230316-WA0032-removebg-preview.png": 8170,
	"./IMG-20231028-WA0053-removebg-preview.png": 9144,
	"./IMG_9202.JPG": 2922,
	"./KNS.png": 9800,
	"./Pi7_Passport_Photo (1).jpg": 5042,
	"./Pi7_Passport_Photo.jpeg": 1017,
	"./Pi7_Passport_Photo.jpg": 2496,
	"./R.png": 32,
	"./SATYA.jpg": 3208,
	"./ats.png": 8876,
	"./aws ca.png": 8029,
	"./aws cac.png": 9986,
	"./aws g.png": 3890,
	"./aws gb.png": 5866,
	"./aws i1.png": 6223,
	"./aws i1c.png": 5796,
	"./aws i2c.png": 7957,
	"./aws2.png": 1131,
	"./awsi2.png": 6392,
	"./bakarya.png": 3719,
	"./bakaryc.png": 2501,
	"./chat.png": 4414,
	"./converter.png": 9154,
	"./country.png": 6812,
	"./download.jpeg": 9609,
	"./edu.jpeg": 5623,
	"./estmi.png": 2320,
	"./glowing-blue-abstract-pattern-computer-language-generated-by-ai.jpg": 4486,
	"./green-leaves-covering-half-stone-wall-diagonally.jpg": 5320,
	"./hero.png": 5284,
	"./herod.png": 3194,
	"./herom.png": 2747,
	"./images (1).jpeg": 6109,
	"./images.jpeg": 3943,
	"./img.png": 7427,
	"./jan.png": 581,
	"./movie app.png": 8227,
	"./multi.png": 7849,
	"./multicloud.png": 4394,
	"./music.png": 8115,
	"./nbc.png": 1397,
	"./nitin-removebg.jpeg": 4145,
	"./nitin-removebg.svg": 3722,
	"./nitin-removebg345.png": 2116,
	"./nitin.jpg": 3978,
	"./oracle.png": 410,
	"./oracle2.png": 5138,
	"./password.png": 3751,
	"./program-development-with-data-terminal-window-displaying-it-coding-language-computer-database-cloud-computing-programming-new-user-interface-with-hmtl-script-close-up.jpg": 4681,
	"./qr.png": 9585,
	"./ser.png": 4784,
	"./serv.png": 2196,
	"./snake.png": 5518,
	"./snake2.png": 5262,
	"./soitlong.jpg": 2283,
	"./suit.png": 6591,
	"./suit1-removebg-preview.png": 7287,
	"./suit1.jpeg": 3807,
	"./techverra.png": 7786,
	"./weather.png": 8598
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;